import { applicationName } from "../../../utils/applicationName.es.js";
import { deepEquals } from "../../../utils/deepEquals.es.js";
import { eventProducerUrl } from "../../../utils/eventProducerUrl.es.js";
import { getMerkleIds } from "./getMerkleIds.es.js";
import { logger } from "../../../utils/logger.es.js";
import { merkleDataTracker, setMerkleDataTracker } from "../../../utils/merkleDataTracker.es.js";
import { v as v4 } from "../../../v4-88c20f3b.js";
import { getVisitId } from "../visitId/visitId.es.js";
import "../../../cookies-04bd2321.js";
import "../../../waitFor-1b67bbb8.js";
import "../../../cookieHandler-ac6954c1.js";
import "../visitId/adapter.es.js";
import "../timeOnPage/timeOnPage.es.js";
import "../visitId/constants.es.js";
import "../visitId/processUrlVisitId.es.js";
import "../visitId/utils.es.js";
const merkleTimeCalculation = Date.now();
const initializeMerkleListener = () => {
  if (typeof window === "undefined") {
    return;
  }
  window.addEventListener("_svdatalayer_ready", () => {
    const timeDifference = Date.now() - merkleTimeCalculation;
    logger.info(
      `MerkleTime: ${timeDifference}ms (${(timeDifference / 1e3).toFixed(2)}s)`
    );
    logger.info("Merkle event _svdatalayer_ready received");
    fireMerkleEvent();
  });
};
const fireMerkleEvent = async () => {
  const merkleData = await getMerkleIds();
  const isEqual = deepEquals(merkleDataTracker, merkleData);
  if (!isEqual && merkleData) {
    setMerkleDataTracker(merkleData);
    const payload = {
      event_origin: "client",
      event_id: v4(),
      application: applicationName,
      event_datetime: Date.now(),
      event_type: "track",
      event_action: "merkle_event_fired",
      event_name: "merkle_datalayer_ready",
      ids: {
        visit_id: getVisitId(),
        ...merkleData
      }
    };
    const requestOptions = {
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
      method: "POST"
    };
    try {
      fetch(eventProducerUrl, requestOptions);
    } catch (e) {
      logger.error("analytics-merkleId: track event failed");
    }
  }
};
const analyticsMerkleIds = () => {
  initializeMerkleListener();
  return {
    name: "analytics-merkleId",
    page: async ({ payload }) => {
      try {
        const ids = payload.properties.ids || {};
        const merkleData = await getMerkleIds();
        const allIds = { ...ids, ...merkleData ?? {} };
        payload.properties = {
          ...payload.properties,
          ids: allIds
        };
      } catch (error) {
        logger.error("Failed to process merkle IDs:", error);
      }
    },
    track: async ({ payload }) => {
      try {
        const ids = payload.properties.ids || {};
        const merkleData = await getMerkleIds();
        const allIds = { ...ids, ...merkleData ?? {} };
        payload.properties = {
          ...payload.properties,
          ids: allIds
        };
      } catch (error) {
        logger.error("Failed to process merkle IDs:", error);
      }
    }
  };
};
export {
  analyticsMerkleIds
};
